import {createRouter, createWebHistory, RouteRecordRaw} from "vue-router";
import HomeView from "@/views/HomeView.vue";
import PikuTradeView from "@/views/PikuTradeView.vue";
import About from "@/views/About.vue";
import CGJView from "@/views/CGJView.vue";
import ReferundumView from "@/views/ReferendumView.vue";
import StageView from "@/views/StageView.vue";
import CompetenceView from "@/views/CompetenceView.vue";
import NDIView from "@/views/NDIView.vue";
import HomeLabView from "@/views/HomeLabView.vue";
import CVView from "@/views/CVView.vue";
import SAEInfraView from "@/views/SAEInfraView.vue";


const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/about",
        name: "about",
        component: About,
    },
    {
        path: "/home",
        name: "homeAlias",
        component: HomeView,
    },
    {
        path: "/pikuTrade",
        name: "pikuTrade",
        component: PikuTradeView,
    },
    {
        path: "/codeGameJam",
        name: "cgj",
        component: CGJView,
    },
    {

        path: "/referendum",
        name: "referendum",
        component: ReferundumView,
    },
    {path: "/stage", name: "stage", component: StageView},
    {path: "/competences", name: "competences", component: CompetenceView},
    {path: "/ndi", name: "ndi", component: NDIView},
    {path: "/homelab", name: "homelab", component: HomeLabView},
    {path: "/cv", name: "cv", component: CVView},
    {path: "/sae-infra", name: "sae-infra", component: SAEInfraView},


];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
